import { create } from 'zustand';
import type { Partner, Permission, Role, User } from '~/types/auth';

type AuthState = {
    isAuthenticated: boolean;
    user: User | null;
    error: string | null;
    roles: Role[];
    email: string;
    permissions: Permission[];
    partners: Partner[];
    setAuthData: (data: Partial<AuthState>) => void;
    resetAuthData: () => void;
    setPartners: (partners: Partner[]) => void;
};

let authDataReseter: () => void;

const initialState = {
    isAuthenticated: false,
    user: null,
    error: null,
    email: '',
    roles: [],
    permissions: [],
    partners: [],
};

export const useAuthStore = create<AuthState>((set) => {
    authDataReseter = () => set(initialState);

    return {
        ...initialState,
        setAuthData: (data) => set((state) => ({ ...state, ...data })),
        resetAuthData: () => set(initialState),
        setPartners: (partners) => set((state) => ({ ...state, partners })),
    };
});
